.reorderableNavItem {
  transition: transform 150ms ease;
}

/* Shifts are only animated during a drag. Once the drag ends the tabs are already
   in their final positions, so animating the transforms away would make the
   displaced tabs appear to slide in from the side */
.reorderableNavItemStatic {
  transition: none;
}

.reorderableNavItemDraggable {
  cursor: grab;
}

.reorderableNavItemDragging {
  opacity: 0;
  cursor: grabbing;
}

/* The offsets are measured per tab, so a tab can move across rows when the strip wraps */
.reorderableNavItemShifted {
  transform: translate(var(--mos-reorderable-dx, 0px), var(--mos-reorderable-dy, 0px));
}

.reorderableNavDragImage {
  position: absolute;
  top: -1000px;
  left: -1000px;
  pointer-events: none;
}
